import React, { Suspense } from 'react';
import { CircularProgress } from '@mui/material';
import { useCircadianAnalysis } from '../../../../../data-access';
import { useEnergyTrend } from '../../../../../hooks';
import './SimpleCircadianChart.scss';

const LazyCircadianChart = React.lazy(
  () => import('../../../DataCircadianDashboard/CircadianChart/CircadianChart')
);

const SimpleCircadianChart = () => {
  const { dataTrendPeriod } = useEnergyTrend();
  const {
    selectedDateCircadianChartData,
    avgCircadianChartData,
    selectedDateEnergyFluctuations,
    isFetchingSelectedCircadian,
    isFetchingAvgCircadian,
  } = useCircadianAnalysis();

  const isWeekly = dataTrendPeriod === 'weekly';

  if (isWeekly) return null;

  return (
    <div className="simple-circadian-chart">
      {isFetchingSelectedCircadian || isFetchingAvgCircadian ? (
        <div className="simple-circadian-chart__loading">
          <CircularProgress />
        </div>
      ) : (
        <Suspense
          fallback={
            <div className="simple-circadian-chart__loading">
              <CircularProgress />
            </div>
          }
        >
          <LazyCircadianChart
            selectedDateCircadianData={selectedDateCircadianChartData}
            selectedDateEnergyFluctuations={selectedDateEnergyFluctuations}
            avgCircadianData={avgCircadianChartData}
          />
        </Suspense>
      )}
    </div>
  );
};

export default SimpleCircadianChart;
